<!--
 * @Description: 
-->
<!--
 * @Description: 
-->
<template>
    <div>
      <!-- 顶部图片 -->
      <div class="top-pic">
        <img src="../../assets/about/about-banner.png" alt="">
      </div>
      <div class="content">
        <div class="content-center">
          <div class="title">了解埃诺登</div>
          <div class="pic">
            <div class="pic-item">
                <img src="../../assets/about/about-pic1.png" alt="">
            </div>
          </div>
          <div class="text" style="margin-top: 40px;">
            北京艾诺登科技有限公司成立于2013年，是李意大利C.L.C
            Scientific种植系统大中华区总代理，公司销售服务网络覆盖全国，主要产品涵盖口腔种植体、口腔种植修复配件、手术器械和数字化解决方案等，艾诺登践行创新和与时俱进的精神，倾力打造让牙科专家及患者信赖的高品质口腔产品及完善服务。
          </div>
          <div class="text">
            艾诺登重视产品的研发和客户教育，与I.D.I.S.（欧洲牙科与种植协会）、意大利帕多瓦大学、米兰大学、哥德堡大学等开展广泛的合作，形成专业的培训服务体系，为推广种植体的临床知识和在市场上保持竞争力提供了学术和科学数据支持。
          </div>
          <div class="text" style="margin-bottom: 106px;">
            在国内外种植专家的支持和关注下，艾诺登将一如既往，进无止境，以卓越的产品、可靠的质量、贴心的服务，实现企业、医生、患者的全面共赢。
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {};
    }
  };
  </script>
  <style lang="css" scoped>
  .top-pic {
    max-height: 480px;
    min-height:280px ;
  }
  .top-pic img {
    width: 100%;
    max-height: 480px;
    min-height:280px ;
  }
  .content {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  
  .content-center {
    width: 1000px;
  }
  
  .title {
    font-size: 20px;
    line-height: 60px;
    margin-top: 20px;
    margin-bottom: 30px;
    border-bottom: 1px solid #eeeeee;
  }
  .pic-item {
    width: 1000px;
    background-color: #eeeeee;
    height: 287px;
  }
  .pic-item img {
    width: 1000px;
    background-color: #eeeeee;
    height: 287px;
  }
  .text {
    line-height: 26px;
    margin-top: 26px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #333333;
  }
  </style>
  